import React, { ReactNode } from 'react';

interface FooterColumnProps {
  title: string;
  children: ReactNode;
}

export default function FooterColumn({ title, children }: FooterColumnProps) {
  return (
    <div>
      <h4 className="font-syne text-white font-bold text-sm mb-5">{title}</h4>
      {children}
    </div>
  );
}
